export default __webpack_public_path__ + "static/Leaf7-6555741d607ded56646948e50b3eacf4.png";